import { useMemo } from 'react';
import {
  ClosePoPermissions,
  CompleteInvoicePermissions,
} from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';

export const viewInvoiceCategories = [
  { value: 0, label: 'Show All Active' },
  { value: 1, label: 'Show All' },
  { value: 2, label: 'Show Only Invoices' },
  { value: 3, label: 'Show Only Credits' },
  { value: 4, label: 'Show Only Qty Received < 100%' },
  { value: 5, label: 'Show Only Qty Received > 100%' },
  { value: 6, label: 'Show Only Completed' },
  { value: 7, label: 'Show Only Deleted' },
  { value: 8, label: 'Show Available to Complete (Invoices)' },
  { value: 9, label: 'Show Ready to Close (POs)' },
  { value: 10, label: 'Show Records with Attachment' },
  { value: 11, label: 'Show Records with No Attachment' },
  { value: 12, label: 'Show Ready to Archive' },
  { value: 13, label: 'Show Only Create New' },
];

const useInvoiceCategories = () => {
  const hasClosePoPermissions = usePermission({ permissions: ClosePoPermissions, or: true });
  const hasCompleteInvoicePermissions = usePermission({
    permissions: CompleteInvoicePermissions,
    or: true,
  });

  const categories = useMemo(() => {
    let categories = [...viewInvoiceCategories];
    if (!hasClosePoPermissions) {
      categories = categories.filter((item) => item.label !== 'Show Ready to Close (POs)');
    }
    if (!hasCompleteInvoicePermissions) {
      categories = categories.filter(
        (item) => item.label !== 'Show Available to Complete (Invoices)'
      );
    }
    return categories;
  }, [hasClosePoPermissions, hasCompleteInvoicePermissions]);

  return categories;
};

export default useInvoiceCategories;
